<template>
  <v-card>
    <v-card-title>QR List</v-card-title>
    <div>
      <v-card-text>
        <v-row>
          <v-col
            cols="6"
          >
            <v-text-field
              v-model="search"
              :append-icon="icons.mdiMagnify"
              label="Search"
              single-line
              hide-details
              dense
              outlined
              @keyup="searchData"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- Table -->
      <div class=" col-12">
        <div class=" col-5 ">
        </div>

        <div class="text-right col-2 ">
          <v-btn
            color="primary"
            block
            @click="openAddForm"
          >
            <v-icon>{{ icons.mdiPlus }}</v-icon>Upload QR
          </v-btn>
        </div>
      </div>
      <br>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :options.sync="options"
        :server-items-length="totalItems"
        class="table-kitchen-sink"
      >
        <template v-slot:item.file_url="{ item }">
          <v-img
            contain
            height="64"
            max-width="64"
            :src="item.file_url"
          ></v-img>
          <!-- Delete dialog -->
        </template>
        <template v-slot:item.actions="{ item }">
          <!-- Delete button -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="deleteItemConfirmation(item)"
              >
                {{ icons.mdiDeleteOutline }}
              </v-icon>
            </template>
            <span>Delete</span>
          </v-tooltip>

          <!-- Delete dialog -->
          <c-dialog
            v-model="isDeleteItemDialogVisible"
            @onConfirm="deleteItem"
          >
            Are you sure want to delete ?
          </c-dialog>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import { mdiMagnify, mdiPlus, mdiDeleteOutline } from '@mdi/js'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
	components: {},
	data() {
		return {
			isDeleteItemDialogVisible: false,

			headers: [
				{ text: 'Title', value: 'title' },
				{ text: 'Start Date', value: 'start_date' },
				{ text: 'End Date', value: 'end_date' },
				{ text: 'QR', value: 'file_url' },
				{ text: 'Created date', value: 'created_at' },
				{
					text: 'ACTIONS',
					value: 'actions',
					sortable: false,
					width: '150px',
				},
			],
			icons: { mdiMagnify, mdiPlus, mdiDeleteOutline },
		}
	},
	computed: {
		...mapGetters('qrUpload', ['items', 'totalItems']),

		options: {
			get() {
				return this.$store.getters['qrUpload/options']
			},
			set(value) {
				this.$store.commit('qrUpload/SET_OPTIONS', value)
			},
		},
		search: {
			get() {
				return this.$store.getters['qrUpload/search']
			},
			set(value) {
				this.$store.commit('qrUpload/SET_SEARCH', value)
			},
		},

	},
	watch: {
		options() {
			this.datatable()
		},
	},

	methods: {
		searchData: _.debounce(function fn() {
			this.datatable()
		}, 400),

		datatable() {
			this.$store.dispatch('qrUpload/datatable')
		},
		openAddForm() {
			this.$router.push('/qr/create')
		},
		deleteItemConfirmation(item) {
			this.selectedItem = JSON.parse(JSON.stringify(item))
			this.isDeleteItemDialogVisible = true
		},
		deleteItem() {
			this.$store
				.dispatch('qrUpload/destroy', this.selectedItem.id)
				.then(response => {
					this.$store.commit('app/SET_SNACKBAR_SUCCESS', response.data?.message)
					this.datatable()
				})
				.catch(error => {
					this.$store.commit('app/SET_SNACKBAR_ERROR', error.response.data?.message)
				})
		},
	},
}
</script>

<style scoped>

</style>
